export default {
  list: {
    title: 'アカウント管理',
    createButton: 'アカウント登録',
    searchPlaceholder: 'ユーザー名/メールアドレスを検索',
    columns: {
      username: 'ユーザー名',
      email: 'メールアドレス',
      department: '部署名称',
      role: 'アカウントタイプ',
      status: '状態',
      creator: '登録者',
      createTime: '登録日時',
      operations: '操作',
      createBySystem: 'システム追加',
    },
    operations: {
      edit: '編集',
      delete: '削除',
    },
  },
  createDialog: {
    title: 'アカウント登録',
    editTitle: 'アカウント編集',
    username: 'ユーザー名',
    usernamePlaceholder: '入力してください',
    email: 'メールアドレス',
    emailPlaceholder: '入力してください',
    department: '部署名称',
    departmentPlaceholder: '入力してください',
    role: 'アカウントタイプ',
    rolePlaceholder: '選択してください',
    accountColor: '連絡役割',
    admin: 'オーナー',
    normal: '一般',
    adminHint: '企業情報作成変更できる',
    normalHint: '作成済みの社員及びタスクのみ管理',
    cancel: 'キャンセル',
    confirm: '登録',
    accountExists: 'アカウントは既に追加されています',
    fetchRolesError: '役割リストの取得に失敗しました',
    validation: {
      usernameRequired: 'ユーザー名を入力してください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '入力されたメールアドレスの形式が正しくありません',
      accountExists: 'アカウントは既に存在します。',
      accountExistsInOtherCompany: '該当アカウントはすでに別の企業に所属しています。元の会社の管理者に連絡して削除いただくか、別のメールアドレスをご使用ください。',
      accountAlreadyCreated: '該当アカウントは既に登録されています',
      departmentRequired: '部署名称を入力してください',
      roleRequired: '役割を選択してください',
    },
  },
  status: {
    active: 'アクティブ',
    unactive: '非アクティブ',
    lock: 'ロック',
  },
  deleteDialog: {
    title: 'アカウント削除',
    content: 'アカウントを削除した後、Careerグロハブにログインすることができません。削除しますか？',
  },
  editDialog: {
    title: 'お知らせ',
    content: '自身のアカウントは編集できません',
  },
  detail: {
    title: '個人情報',
    username: 'ユーザー名',
    email: 'メールアドレス',
    password: 'パスワード',
    department: '部署名称',
    role: '役割',
    save: '保存',
    cancel: 'キャンセル',
    updateEmail: 'メールアドレス変更',
    modifyPassword: 'パスワード変更',
  },
  updateEmailDialog: {
    title: 'メールアドレス変更',
    step1Description: '新しいメールアドレスを入力してください。新しいメールアドレスに確認リンクを送信します。リンクを通じて確認後、新しいメールアドレスが有効になります。',
    step2Description: '{email}にメールアドレス変更のメールを送信しました。メールを受信し、メール内の指示に従って操作してください。',
    inputPlaceholder: '入力してください',
    cancel: 'キャンセル',
    confirm: '確定',
    known: '了解しました',
    validation: {
      emailRequired: 'メールアドレスを入力してください',
    },
  },
  updatePasswordDialog: {
    title: 'パスワード変更',
    oldPassword: '旧パスワード',
    newPassword: '新パスワード',
    confirmPassword: '新パスワードを再入力',
    inputPlaceholder: '入力してください',
    newPasswordPlaceholder: 'パスワードは8文字以上で英字と数字を含める必要があります',
    cancel: 'キャンセル',
    confirm: '確定',
    successMessage: 'パスワードが正常に変更されました',
    validation: {
      oldPasswordRequired: '旧パスワードを入力してください',
      newPasswordRequired: '新パスワードを入力してください',
      passwordLength: 'パスワードは8文字以上である必要があります',
      passwordFormat: 'パスワードは英字と数字を含む必要があります',
      confirmPasswordRequired: '新パスワードを再入力してください',
      passwordMismatch: '入力されたパスワードが一致しません',
    },
  },
  messages: {
    updateSuccess: '変更が正常に完了しました',
  },
  empty: 'アカウントはまだ追加されていません',
  roles: {
    superAdmin: 'オーナー',
    recruitmentManager: '管理者',
    recruitmentSpecialist: 'HR',
    interviewer: '面接官',
    agentAdmin: '管理者',
    agentUser: '一般',
    businessOp: '運営サポート',
  },
  roleNames: {
    1: 'オーナー',
    4: '管理者',
    5: 'HR',
    6: '面接官',
    2: '管理者',
    3: '一般',
    7: '運営サポート',
  }
};
